import React, { useRef, ChangeEvent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonComponent from '../button';

const CustomButton = withStyles(theme => ({
  root: {
    textTransform: 'none',
    position: 'relative',
  },
}))(ButtonComponent);

interface FileInputButtonProps {
  label: string;
  onChange: (files: FileList | null) => void;
  loading?: boolean;
  acceptedFileTypes?: string;
  multiple?: boolean;
}

const FileInputButton: React.FC<FileInputButtonProps> = ({
  label,
  onChange,
  loading = false,
  acceptedFileTypes,
  multiple = false,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.files);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={acceptedFileTypes}
        multiple={multiple}
        style={{ display: 'none' }}
      />
      <CustomButton
        variant="contained"
        color="primary"
        onClick={handleClick}
        disabled={loading}
        loading={loading}
        style={{
          borderRadius: '0 4px 4px 0',
        }}
      >
        {label}
      </CustomButton>
    </>
  );
};

export default FileInputButton;
